module.exports = __webpack_public_path__ + "img/39.112e401c.jpeg";